import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryValueEntry } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.selectors';

@Pipe({
   name: 'availableDirectoryDataForEntry',
})
export class AvailableDirectoryDataForEntryPipe implements PipeTransform {
   transform(dataEntries: DirectoryValueEntry[] | Observable<DirectoryValueEntry[]>, directoryId: number): Observable<string | number | boolean | Date> {
      let dataEntries$: Observable<DirectoryValueEntry[]>;
      if (isObservable(dataEntries)) {
         dataEntries$ = dataEntries;
      } else {
         dataEntries$ = of(dataEntries);
      }
      return dataEntries$.pipe(map((directoryValueEntries) => directoryValueEntries.find((dataItem) => _.isEqual(dataItem.id, directoryId))?.value ?? ''));
   }
}
